import { keyBy } from '../../../../components/utils/utils'

export default function (campaign, config) {
  const {
    campaignChannel,
    selected_market_abr,
    selected_brand_abr,
    businessunit,
    campaigncategory,
    processtype,
    maintarget,
    businesstype,
    sellingOnline,
    namecomputed,
    business_area,
    legacyexf,
    legacyexp,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    email_list,
    push_list,
    sms_list,
    alwaysOn,
    brands,
    camperContribution,
    ccdbReportEnabled,
    ccdbReportType,
    ccCallsEndDate,
    ccCallsStartDate,
    ccExtractionDaysFreq,
    ccMaxRecordsToExtract,
    ccScript,
    channelPriority,
    contentClassification,
    contributionType,
    cscEngagementLevel,
    description,
    disableOrchestration,
    endDate,
    finality,
    jeepWave,
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    ppExtractionDaysFreq,
    ppExtractionEndDate,
    ppExtractionStartDate,
    ppMaxRecordsToExtract,
    ppProviderId,
    ppTemplateFilename,
    ppUrl1,
    ppUrl2,
    ppUrl3,
    preview,
    recordType,
    segmentType,
    legalBase,
    startDate,
    status,
    touchpoint,
    type
  } = campaign

  return {
    campaignChannel,
    selected_market_abr,
    selected_brand_abr,
    businessunit,
    campaigncategory,
    processtype,
    maintarget,
    businesstype,
    sellingOnline,
    namecomputed,
    business_area,
    legacyexf,
    legacyexp,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    email_list,
    push_list,
    sms_list,
    alwaysOn,
    brands,
    camperContribution,
    ccdbReportEnabled,
    ccdbReportType,
    ccCallsEndDate: ccCallsEndDate || null,
    ccCallsStartDate: ccCallsStartDate || null,
    ccExtractionDaysFreq,
    ccMaxRecordsToExtract,
    ccScript: ccScript || null,
    channelPriority: channelPriority || null,
    contentClassification: contentClassification || null,
    contributionType: contributionType || null,
    cscEngagementLevel,
    description,
    disableOrchestration,
    endDate: endDate || null,
    finality,
    jeepWave: jeepWave || [],
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    ppExtractionDaysFreq,
    ppExtractionEndDate: ppExtractionEndDate || null,
    ppExtractionStartDate: ppExtractionStartDate || null,
    ppMaxRecordsToExtract,
    ppProviderId,
    ppTemplateFilename,
    ppUrl1,
    ppUrl2,
    ppUrl3,
    preview,
    recordType,
    segmentType,
    legalBase,
    startDate: startDate || null,
    status,
    touchpoint,
    type,
    config: _buildConfig(campaign, config)
  }
}

function _buildConfig (campaign, config) {
  const configObject = {}
  if (campaign.config.campaignData) {
    configObject.campaignData = campaign.config.campaignData
  }

  if (campaign.config.contents) {
    configObject.contents = campaign.config.contents || []
  }

  if (campaign.config.offers) {
    configObject.offers = _buildOffers(campaign.config.offers)
  }

  if (campaign.config.filters) {
    configObject.filters = _buildFilters(campaign, config, configObject.offers)
  }

  if (campaign.config.filters_exp) {
    configObject.filters_exp = _buildFilters(campaign, config, configObject.offers, true)
  }

  if (campaign.config.preview) {
    configObject.preview = campaign.config.preview
  }
  if (campaign.config.userPreferences) {
    configObject.userPreferences = campaign.config.userPreferences
  }
  //console.log('config object currently: ', configObject)
  return configObject
}

function _buildOffers (offers) {
  //console.log('offers we are going to build:', offers)
  if (offers && offers[0] && offers[0].sectionId) {
    const keyed = keyBy(offers, 'offerId')
    const mapped = []

    Object.keys(keyed).forEach(offer => {
      const obj = { [offer]: [] }
      const sections = keyed[offer]

      sections.forEach(section => {
        obj[section.offerId].push({
          brand: section.brand,
          codMarket: section.codMarket,
          sectionId: section.sectionId,
          sectionsList: section.groupList.map(g => g.sectionId),
          contentPriority: section.contentPriority,
          tags: section.tags, //from here on
          camper: section.camper,
          currency: section.currency,
          dealerCluster: section.dealerCluster,
          description: section.description,
          endDate: section.endDate,
          engineSize: section.engineSize,
          fleet: section.fleet,
          fuelType: section.fuelType,
          groupList: section.groupList,
          includeOrExcludeVins: section.includeOrExcludeVins,
          itemsList: section.itemsList,
          kmFrom: section.kmFrom,
          kmTo: section.kmTo,
          masterKey: section.masterKey,
          mmvsList: section.mmvsList,
          modelYearFrom: section.modelYearFrom,
          offerId: section.offerId,
          offerType: section.offerType,
          priceValue: section.priceValue,
          range: section.range,
          sectionDescription: section.sectionDescription,
          sectionTitle: section.sectionTitle,
          segment: section.segment,
          startDate: section.startDate,
          timeRangeSelector: section.timeRangeSelector,
          title: section.title,
          vinList: section.vinList
        })
      })

      mapped.push(obj)
    })
    //console.log('OFFERS CREATED (mapped)', mapped)
    return mapped
  } else {
    //console.log('OFFERS CREATED (offers)', offers)
    return offers
  }
}

function _buildFilters (campaign, config, mappedOffers, exp = false) {
  let brands = {}
  let markets = {}
  let jeepWave = {}



  const isInformativeCampaign = campaign.config.userPreferences.onlyInformativeCampaign === null || campaign.config.userPreferences.onlyInformativeCampaign === true
  const isCommercialCampaignWithoutOffers = campaign.config.userPreferences.onlyInformativeCampaign === false && campaign.config.offers.length === 0
  if (isInformativeCampaign || isCommercialCampaignWithoutOffers || exp) {
    brands = campaign.config.campaignData.campaignBrands
    markets = campaign.config.campaignData.markets.selected
    jeepWave = campaign.config.campaignData.jeepWave
    //console.log('FILTERS CREATED (withoutoffers)')
    if (exp) {
      return _mapSingleFiltersSet(campaign.config.filters_exp, config.filters_exp, markets, brands, jeepWave)
    }
    return _mapSingleFiltersSet(campaign.config.filters, config.filters, markets, brands, jeepWave)
  } else {
    let filters = {}
    let offers = mappedOffers.map(offer => Object.values(offer)).flat(2)

    console.log("object is", Object.keys(campaign.config.filters))

    Object.keys(campaign.config.filters).forEach(sectionId => {
      const offer = offers.find(o => o.sectionId === sectionId)
      const filter = campaign.config.filters[sectionId]



      if (offer.brand === 'All') {
        brands = {
          options: campaign.config.campaignData.campaignBrands.options,
          selected: campaign.config.campaignData.campaignBrands.selected
        }
      } else {
        brands = {
          options: campaign.config.campaignData.campaignBrands.options,
          selected: [offer.brand]
        }
      }
      markets = [offer.codMarket]
      jeepWave = campaign.config.campaignData.jeepWave
      filters[sectionId] = _mapSingleFiltersSet(filter, config.filters[sectionId] !== undefined ? config.filters[sectionId] : config.filters, markets, brands, jeepWave)
    })
    //console.log('FILTERS CREATED (with offers)', filters)
    return filters
  }
}

function _mapSingleFiltersSet (filters, configFilters, markets, brands, jeepWave) {
  const filterSet = {
    vocation: {
      options: configFilters.vocation.options,
      selected: (filters.vocation && filters.vocation.selected !== undefined) ? filters.vocation.selected : filters.vocation
    },
    brands: {
      options: brands.options,
      selected: brands.selected
    },
    camper: {
      options: configFilters.camper.options,
      selected: (filters.camper && filters.camper.selected !== undefined) ? filters.camper.selected : filters.camper
    },
    carAges: filters.carAges,
    clientType: {
      options: configFilters.clientType.options,
      selected: (filters.clientType && filters.clientType.selected !== undefined) ? filters.clientType.selected : filters.clientType
    },
    communicationChannelsFilterLogic: {
      options: configFilters.communicationChannelsFilterLogic.options,
      selected: (filters.communicationChannelsFilterLogic && filters.communicationChannelsFilterLogic.selected !== undefined) ? filters.communicationChannelsFilterLogic.selected : filters.communicationChannelsFilterLogic
    },
    dealerCluster: {
      options: configFilters.dealerCluster.options,
      selected: (filters.dealerCluster && filters.dealerCluster.selected !== undefined) ? filters.dealerCluster.selected : filters.dealerCluster
    },
    dealers: {
      selected: (filters.dealers && filters.dealers.selected !== undefined) ? filters.dealers.selected : filters.dealers
    },
    eligibilityUConnectLive: {
      options: configFilters.eligibilityUConnectLive.options,
      selected: (filters.eligibilityUConnectLive && filters.eligibilityUConnectLive.selected !== undefined) ? filters.eligibilityUConnectLive.selected : filters.eligibilityUConnectLive
    },
    emailEngagement: {
      options: configFilters.emailEngagement.options,
      selected: (filters.emailEngagement && filters.emailEngagement.selected !== undefined) ? filters.emailEngagement.selected : filters.emailEngagement
    },
    emailPressure: {
      options: configFilters.emailPressure.options,
      selected: (filters.emailPressure && filters.emailPressure.selected !== undefined) ? filters.emailPressure.selected : filters.emailPressure
    },
    emailReactivity: {
      options: configFilters.emailReactivity.options,
      selected: (filters.emailReactivity && filters.emailReactivity.selected !== undefined) ? filters.emailReactivity.selected : filters.emailReactivity
    },
    engagementConditions: {
      selected: (filters.engagementConditions && filters.engagementConditions.selected !== undefined) ? filters.engagementConditions.selected.filter(row => Object.values(row).some(i => !!i)) : filters.engagementConditions.filter(row => Object.values(row).some(i => !!i))
    },
    engineSize: {
      options: configFilters.engineSize.options,
      selected: (filters.engineSize && filters.engineSize.selected !== undefined) ? filters.engineSize.selected : filters.engineSize
    },
    excludeContactsWithoutAssociatedDealer: {
      options: configFilters.excludeContactsWithoutAssociatedDealer.options,
      selected: (filters.excludeContactsWithoutAssociatedDealer && filters.excludeContactsWithoutAssociatedDealer.selected !== undefined) ? filters.excludeContactsWithoutAssociatedDealer.selected : filters.excludeContactsWithoutAssociatedDealer
    },
    firstRegistrationDate: {
      selected: (filters.firstRegistrationDate && filters.firstRegistrationDate.selected !== undefined) ? filters.firstRegistrationDate.selected : filters.firstRegistrationDate
    },
    fleet: {
      options: configFilters.fleet.options,
      selected: (filters.fleet && filters.fleet.selected !== undefined) ? filters.fleet.selected : filters.fleet
    },
    freeMapUpdate: {
      options: configFilters.freeMapUpdate.options,
      selected: (filters.freeMapUpdate && filters.freeMapUpdate.selected !== undefined) ? filters.freeMapUpdate.selected : filters.freeMapUpdate
    },
    freeMapUpdateInclude: {
      options: configFilters.freeMapUpdateInclude.options,
      selected: (filters.freeMapUpdateInclude && filters.freeMapUpdateInclude.selected !== undefined) ? filters.freeMapUpdateInclude.selected : filters.freeMapUpdateInclude
    },
    fuelTypes: {
      options: configFilters.fuelTypes.options,
      selected: (filters.fuelTypes && filters.fuelTypes.selected !== undefined) ? filters.fuelTypes.selected : filters.fuelTypes
    },
    exp_fuelTypes: {
      options: configFilters.exp_fuelTypes.options,
      selected: (filters.exp_fuelTypes && filters.exp_fuelTypes.selected !== undefined) ? filters.exp_fuelTypes.selected : filters.exp_fuelTypes
    },
    maintenanceModelCluster: {
      options: filters.maintenanceModelCluster.options,
      selected: (filters.maintenanceModelCluster && filters.maintenanceModelCluster.selected !== undefined) ? filters.maintenanceModelCluster.selected : filters.maintenanceModelCluster
    },
    mapCare: {
      options: configFilters.mapCare.options,
      selected: (filters.mapCare && filters.mapCare.selected !== undefined) ? filters.mapCare.selected : filters.mapCare
    },
    mapCareInclude: {
      options: configFilters.mapCareInclude.options,
      selected: (filters.mapCareInclude && filters.mapCareInclude.selected !== undefined) ? filters.mapCareInclude.selected : filters.mapCareInclude
    },
    mapUpdate: {
      options: configFilters.mapUpdate.options,
      selected: (filters.mapUpdate && filters.mapUpdate.selected !== undefined) ? filters.mapUpdate.selected : filters.mapUpdate
    },
    mapUpdateInclude: {
      options: configFilters.mapUpdateInclude.options,
      selected: (filters.mapUpdateInclude && filters.mapUpdateInclude.selected !== undefined) ? filters.mapUpdateInclude.selected : filters.mapUpdateInclude
    },
    markets: {
      selected: markets
    },
    marketingPrivacyConsent: {
      options: configFilters.marketingPrivacyConsent.options,
      selected: (filters.marketingPrivacyConsent && filters.marketingPrivacyConsent.selected !== undefined) ? filters.marketingPrivacyConsent.selected : filters.marketingPrivacyConsent
    },
    mileageTag: {
      options: configFilters.mileageTag.options,
      selected: (filters.mileageTag && filters.mileageTag.selected !== undefined) ? filters.mileageTag.selected : filters.mileageTag
    },
    mileages: {
      selected: (filters.mileages && filters.mileages.selected !== undefined) ? filters.mileages.selected : filters.mileages
    },
    modelYearFrom: {
      options: configFilters.modelYearFrom.options,
      selected: (filters.modelYearFrom && filters.modelYearFrom.selected !== undefined) ? filters.modelYearFrom.selected : filters.modelYearFrom
    },
    monthsFromFirstRegistrationDate: {
      selected: (filters.monthsFromFirstRegistrationDate && filters.monthsFromFirstRegistrationDate.selected !== undefined) ? filters.monthsFromFirstRegistrationDate.selected : filters.monthsFromFirstRegistrationDate
    },
    moparConnect: {
      options: configFilters.moparConnect.options,
      selected: (filters.moparConnect && filters.moparConnect.selected !== undefined) ? filters.moparConnect.selected : filters.moparConnect
    },
    moparConnectInclude: {
      options: configFilters.moparConnectInclude.options,
      selected: (filters.moparConnectInclude && filters.moparConnectInclude.selected !== undefined) ? filters.moparConnectInclude.selected : filters.moparConnectInclude
    },
    mvs: {
      selected: (filters.mvs && filters.mvs.selected !== undefined) ? filters.mvs.selected : filters.mvs
    },
    mvsToExclude: {
      selected: (filters.mvsToExclude && filters.mvsToExclude.selected !== undefined) ? filters.mvsToExclude.selected : filters.mvsToExclude
    },
    ocfDate: {
      selected: (filters.ocfDate && filters.ocfDate.selected !== undefined) ? filters.ocfDate.selected : filters.ocfDate
    },
    profilingPrivacyConsent: {
      options: configFilters.profilingPrivacyConsent.options,
      selected: (filters.profilingPrivacyConsent && filters.profilingPrivacyConsent.selected !== undefined) ? filters.profilingPrivacyConsent.selected : filters.profilingPrivacyConsent
    },
    purchasedServicesAndAccessories: {
      options: configFilters.purchasedServicesAndAccessories.options,
      selected: (filters.purchasedServicesAndAccessories && filters.purchasedServicesAndAccessories.selected !== undefined) ? filters.purchasedServicesAndAccessories.selected : filters.purchasedServicesAndAccessories
    },
    registrationOnMOC: {
      options: configFilters.registrationOnMOC.options,
      selected: (filters.registrationOnMOC && filters.registrationOnMOC.selected !== undefined) ? filters.registrationOnMOC.selected : filters.registrationOnMOC
    },
    sectionTitle: filters.sectionTitle,
    segment: {
      options: configFilters.segment.options,
      selected: (filters.segment && filters.segment.selected !== undefined) ? filters.segment.selected : filters.segment
    },
    targetCluster: {
      options: configFilters.targetCluster.options,
      selected: (filters.targetCluster && filters.targetCluster.selected !== undefined) ? filters.targetCluster.selected : filters.targetCluster
    },
    targetRange: {
      options: configFilters.targetRange.options,
      selected: (filters.targetRange && filters.targetRange.selected !== undefined) ? filters.targetRange.selected : filters.targetRange
    },
    tbm: {
      options: configFilters.tbm.options,
      selected: (filters.tbm !== undefined && filters.tbm.selected !== undefined) ? filters.tbm.selected : filters.tbm
    },
    vin: {
      selected: (filters.vin && filters.vin.selected !== undefined) ? filters.vin.selected : null
    },
    vinToExclude: {
      selected: (filters.vinToExclude && filters.vinToExclude.selected !== undefined) ? filters.vinToExclude.selected : filters.vinToExclude
    },
    warrantyExtension: {
      carsWithoutWarranties: {
        options: configFilters.warrantyExtension.carsWithoutWarranties.options,
        selected: (filters.warrantyExtension.carsWithoutWarranties !== undefined && filters.warrantyExtension.carsWithoutWarranties.selected !== undefined) ? filters.warrantyExtension.carsWithoutWarranties.selected : filters.warrantyExtension.carsWithoutWarranties
      },
      contracts: {
        options: configFilters.warrantyExtension.contracts.options,
        selected: (filters.warrantyExtension.contracts !== undefined && filters.warrantyExtension.contracts.selected !== undefined) ? filters.warrantyExtension.contracts.selected : filters.warrantyExtension.contracts
      },
      fromDate: filters.fromDate !== undefined ? filters.fromDate : null,
      toDate: filters.toDate !== undefined ? filters.toDate : null
    },
    warrantyExtensionInclude: {
      options: configFilters.warrantyExtensionInclude.options,
      selected: (filters.warrantyExtensionInclude && filters.warrantyExtensionInclude.selected !== undefined) ? filters.warrantyExtensionInclude.selected : filters.warrantyExtensionInclude
    },
    zipCodes: {
      selected: (filters.zipCodes && filters.zipCodes.selected !== undefined) ? filters.zipCodes.selected : filters.zipCodes
    }
  }

  if (jeepWave) {
    filterSet.jeepWave = {
      options: jeepWave.options,
      selected: jeepWave.selected
    }
  }

  return filterSet
}
